<template>
     <a-modal title="竞价详情" :visible="visible" :confirmLoading="loading" width="60%"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel" ok-text="出价" cancel-text="取消">
        <div class="main-body">
          <p style="margin-left:2%;">竞拍编号：{{ currentItem.biddingCode }}</p>     
          <p><span>竞价项目：{{ currentItem.projectName }}</span><span>距离结束：{{ setTime }}</span><span>报名人数：{{ currentItem.applyNum }}</span></p> 
          <p><span>公示时间：{{ currentItem.publicTime }}</span><span>开始时间：{{ currentItem.startTime }}</span><span>结束时间：{{ currentItem.actualEndTime }}</span></p>
          <p><span>起拍价：{{ currentItem.biddingPrice }}万元</span>
              <span>当前价：{{ currentItem.currentPrice }}元</span>
              <span>最新出价方：{{ currentItem.userName || '---' }}<a-button style="margin-left:20px;" type="primary" size="small" @click="getData">刷新</a-button></span></p>  
          <div>
             <div style="margin-left: 2%;"> 
               <span>加价幅度(元)</span>
                <a-select  v-model="biddingUp" placeholder="请选择加价幅度" style="width:100%" @change="getPrice">
                    <a-select-option v-for="(item,index) in biddingUpList" :key="index" :value="item">{{ item }}</a-select-option>
                </a-select>
             </div> 
             <div  style="margin-left: 2%;">
                <span>我的报价(元)</span>
                <a-input v-model="currentPrice" placeholder="请输入我的报价" />
             </div>
          </div>
        </div>
    </a-modal>
</template>
<script>
export default {
     data(){
         return{
            visible:false,
            currentItem:{},
            loading:false,
            biddingUpList:[],
            biddingUp:undefined,
            currentPrice:'',
            biddingId:'',
            setTime:'',
            finishDate:'',
         }
     },
     methods:{
        showDialog(item){
            this.biddingId = item.biddingId;
            this.getData(item);
            this.visible = true;
        },
        getData(){
            this.$https.get(`/portal/bidding/getOngoingBiddingDetail/${this.biddingId}`).then(res=>{
                   if(res.code == 200){
                        this.currentItem = res.data;
                        this.biddingUpList = res.data.biddingUpList;
                        this.finishDate = res.data.actualEndTime;
                        this.$https.get('/portal/bidding/getDate').then(res=>{
                            this.setTime = '';
                            this.showtime(res);
                        })
                    }
            })
        },
        showtime(res) {
            let nowtime=new Date(res),//获取当前时间
        　　    endtime=new Date(this.finishDate);//定义结束时间
            let lefttime=endtime.getTime()-nowtime.getTime(),//距离结束时间的毫秒数
                leftd = Math.floor(lefttime/(1000*60*60*24)),//计算天数
                lefth = Math.floor(lefttime/(1000*60*60)%24),//计算小时数
                leftm = Math.floor(lefttime/(1000*60)%60),//计算分钟数
                lefts = Math.floor(lefttime/1000%60);//计算秒数
                if(lefth<10){
                    lefth ='0' + lefth
                }
                if(leftm<10){
                    leftm = '0' + leftm
                }
                if(lefts<10){
                    lefts = '0' + lefts
                }
                this.setTime = leftd+"天"+lefth+":"+leftm+":"+lefts
                setTimeout(()=>{
                    let currentTime = new Date(res).getTime() + 1000
                    this.showtime(currentTime);
                },1000)
        },     
        handleOk(){
            let reg = /^\+?[1-9][0-9]*$/;
            if(!reg.test(this.currentPrice)){
                this.$message.error('请输入正整数报价');
                return false;
            }
            let obj = {
                biddingId:this.biddingId,
                offerPrice:this.currentPrice
            }
            this.$https.post('/portal/bidding/projectBiddingOffer',obj).then(res=>{
                  if(res.code == 200){
                      this.$message.success('出价成功');
                      this.getData();
                  }else{
                      this.$message.warn(res.msg)
                  }
            })
           
        },
        getPrice(){
           this.currentPrice = Number(this.currentItem.currentPrice) + Number(this.biddingUp)
        },
        handleCancel(){
           this.visible = false;
        },
     }
}
</script>

<style lang="less" scoped>
.main-body{
    p{
        display: flex;
        span{
            width: 32%;
            &:nth-of-type(1){
                margin-left:2%;
            }
        }
    }
    div{
        display: flex;
        div{
            width: 43%;
            display: flex;
            flex-direction: column;
            span{
                line-height: 50px;
            }
        }
    }
}
</style>